module.exports = "/_next/static/images/participation1-6ae92fd5da5d35eb3b0573048a503bf0.svg";